import { Icon, IconButton } from '@branch-messenger/willow-ui'
import { MessageChatQuestionCircle } from '@branch-messenger/willow-ui/icons'
import { useMatch } from '@tanstack/react-router'
import { useIntersectionObserver } from '@uidotdev/usehooks'
import { FC, Suspense } from 'react'

import { NavContainer, StyledRootLayoutHeader } from '../styles'
import { AccountDropdown } from './AccountDropdown'
import { NavMenu } from './NavMenu'
import { OrganizationSelector } from './OrganizationSelector'
import { OrgLogo } from './OrgLogo'

type Props = {
  ref?: React.Ref<HTMLDivElement>
}

export const RootLayoutHeader: FC<Props> = ({ ref }) => {
  const [scrollWatcherRef, scrollWatcher] = useIntersectionObserver({
    threshold: 0.1,
    root: null,
    rootMargin: '10px 0px 0px 0px',
  })

  const authenticatedRoute = useMatch({
    from: '/_authenticated',
    shouldThrow: false,
  })

  return (
    <>
      <div data-scroll-watcher ref={scrollWatcherRef} />
      <StyledRootLayoutHeader
        $pageScrolled={!!scrollWatcher && !scrollWatcher.isIntersecting}
        ref={ref}
      >
        <NavContainer>
          <Suspense>
            <OrgLogo />
            {authenticatedRoute && <NavMenu />}
          </Suspense>
        </NavContainer>
        {authenticatedRoute && (
          <Suspense>
            <OrganizationSelector />
          </Suspense>
        )}
        <IconButton onClick={() => window.Smooch?.open()}>
          <Icon Icon={MessageChatQuestionCircle} size={6} />
        </IconButton>
        <AccountDropdown />
      </StyledRootLayoutHeader>
    </>
  )
}

RootLayoutHeader.displayName = 'RootLayoutHeader'
